
import ChatItem from "~/components/Chat/ChatItem.vue"

export default {
  name: "ChatTyping",
  components: {
    ChatItem,
  },
}
